import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import requests from 'app/requests/Order/Order.requests'
import simpleApi from 'app/services/simpleApi'
import {
    InternalTransportRequestParams,
} from '../CreateManuallyForm/createManuallyForm.types'

const useCreateInternalOrder = (onSuccess: ({
    orderNumber,
}: {orderNumber: string}) => void) => {
    const token = useJWTToken()
    const {
        onError,
    } = useHandleStatusRequest({
        id: 'CreateInternalOrder',
    })

    return useMutation({
        mutationFn: (data: Partial<InternalTransportRequestParams>) => {
            return simpleApi({
                ...requests.createInternalTransport({
                    data,
                }),
                token,
            })
        },
        onSuccess,
        onError,
    })
}

export default useCreateInternalOrder
